import * as React from 'react'
import { PlusOutlined, IdcardOutlined } from '@ant-design/icons'
import { Button, Col, Input, List, PageHeader, Row } from 'antd'
import { RouteComponentProps, withRouter } from 'react-router'

import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'
import { IClienteAdminService } from '../../services/ClienteAdminService'

import { TTAvatar } from '../shared/TTAvatar'

import { PagedBaseState } from '../../models/PagedBaseState'
import { SearcherBaseModel } from '../../models/SearcherBaseModel'
import { ClienteModel } from '../../models/ClienteModels'
import { ai } from '../../TelemetryService'
import { withAITracking } from '@microsoft/applicationinsights-react-js'

const { Search } = Input

class ClientiState extends PagedBaseState<ClienteModel> {
}

export class PageClientiComp extends React.Component<RouteComponentProps, ClientiState> {

    service: IClienteAdminService

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.CLIENTE_ADMIN_SERVICE)
        this.state = new ClientiState()
    }

    componentDidMount() {
        this.search(1)
    }

    onClienteClick = id => {
        this.props.history.push(`Cliente/Scheda/${id}`)
    }

    onClienteNewClick = () => {
        this.props.history.push(`Cliente/Crea`)
    }

    onSearch = text => {
        this.setState({ Searcher: text })
        this.search(1)
    }

    onPageChange = page => {
        this.search(page)
    }

    search = async (page: number) => {
        const searcher: SearcherBaseModel = {
            Pagina: page,
            FullText: this.state.Searcher,
            Righe: 20
        }

        let resp = await this.service.Search(searcher)
        this.setState({ Data: resp, Page: page })
    }

    render() {
        return (
            <PageHeader title="Clienti" extra={[
                <Button type="primary" key="edit-customer" icon={<PlusOutlined />} onClick={() => this.onClienteNewClick()}>Crea</Button>
            ]}>
                <Row>
                    <Col offset={1} span={22} >
                        <Search placeholder="Cerca cliente"
                            onSearch={value => this.onSearch(value)}
                            value={this.state.Searcher}
                            onChange={e => this.setState({ Searcher: e.target.value })}
                            enterButton />
                    </Col>
                </Row>
                <br />
                <List
                    dataSource={this.state.Data.Data}
                    rowKey={it => it.Id}
                    pagination={{
                        onChange: (page) => this.onPageChange(page),
                        pageSize: 20,
                        total: this.state.Data.Total,
                        current: this.state.Page
                    }}
                    renderItem={item => (
                        <List.Item key={item.Id}>
                            <List.Item.Meta
                                avatar={<TTAvatar icon={<IdcardOutlined />} />}
                                title={<a onClick={() => this.onClienteClick(item.Id)}>{item.Descrizione}</a>}
                                description={`${item.Email} - ${item.Telefono}`}
                            />
                        </List.Item>
                    )} />
            </PageHeader>
        )
    }
}

export const PageClienti = withRouter(withAITracking(ai.reactPlugin, PageClientiComp,"PageClienti"))
